/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/scripts/sections/simple_video.js ***!
  \**********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var simpleVideo = function simpleVideo() {
  return {
    isDesktopPlaying: false,
    isMobilePlaying: false,
    isMobile: false,
    hidePauseButton: false,
    get isVideoPlaying() {
      var _this$$refs = this.$refs,
        thisParentContainer = _this$$refs.thisParentContainer,
        desktopVideo = _this$$refs.desktopVideo,
        mobileVideo = _this$$refs.mobileVideo;
      if (desktopVideo && mobileVideo) {
        return this.isMobile ? this.isMobilePlaying : this.isDesktopPlaying;
      } else {
        return this.isDesktopPlaying;
      }
    },
    init: function init() {
      this.updateMobileFlag();
    },
    updateMobileFlag: function updateMobileFlag() {
      this.isMobile = window.matchMedia("(max-width: 990px)").matches;
    },
    playPauseToggle: function playPauseToggle($el) {
      var _this$$refs2 = this.$refs,
        thisParentContainer = _this$$refs2.thisParentContainer,
        desktopVideo = _this$$refs2.desktopVideo,
        mobileVideo = _this$$refs2.mobileVideo;
      if (this.isVideoPlaying) {
        if (desktopVideo && !mobileVideo) {
          if ($el.classList.contains('btn')) {
            desktopVideo.pause();
          } else {
            desktopVideo.pause();
          }
        } else if (desktopVideo && mobileVideo) {
          if (this.isMobile) {
            if ($el.classList.contains('btn')) {
              mobileVideo.pause();
            } else {
              mobileVideo.pause();
            }
          } else {
            if ($el.classList.contains('btn')) {
              desktopVideo.pause();
            } else {
              desktopVideo.pause();
            }
          }
        }
        this.hidePauseButton = false;
      } else {
        if (desktopVideo && !mobileVideo) {
          if ($el.classList.contains('btn')) {
            desktopVideo.play();
          } else {
            desktopVideo.play();
          }
        } else if (desktopVideo && mobileVideo) {
          if (this.isMobile) {
            if ($el.classList.contains('btn')) {
              mobileVideo.play();
            } else {
              mobileVideo.play();
            }
          } else {
            if ($el.classList.contains('btn')) {
              desktopVideo.play();
            } else {
              desktopVideo.play();
            }
          }
        }
        this.hidePauseButton = true;
      }
    },
    showPauseButtonOnHover: function showPauseButtonOnHover() {
      if (this.isVideoPlaying) {
        this.hidePauseButton = false;
      }
    },
    hidePauseButtonOnHover: function hidePauseButtonOnHover() {
      if (this.isVideoPlaying) {
        this.hidePauseButton = true;
      }
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (simpleVideo);
document.addEventListener("alpine:init", function () {
  Alpine.data("simple_video", simpleVideo);
});
/******/ })()
;